import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import AddUserProject from '../MyProfile/user-projects/AddUserProject';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { Guard } from '../../features/Guard';

const NoProject = ({ fetchProjectData }) => {
  const [open, setOpen] = useState(false);
  return (
    <Card>
      <Card.Body>
        <div className="d-flex align-items-center flex-column p-3">
          <Typography sx={{ mb: 1, fontSize: '20px' }}>
            No Projects Available
          </Typography>
          <Guard policy="ManageProjects"
            fallback={
              <Typography>
                Please wait for your organization admin to assign some projects.
              </Typography>
            }
          >
            <Button
              variant="link"
              onClick={() => setOpen(true)}
              style={{ textDecoration: 'none' }}>
              <Add /> Add Project
            </Button>
          </Guard>
        </div>
      </Card.Body>
      <AddUserProject fetchProjectData={fetchProjectData} open={open} setOpen={setOpen} />
    </Card>
  );
};

export default NoProject;
